import { FC, memo } from 'react';

interface IDragOverlayProps {
  title: string;
  width?: string;
  height?: string;
}

const DragOverlay: FC<IDragOverlayProps> = ({
  title,
  width = '786px',
  height = '449px',
}) => (
  <div className="fixed inset-0 bg-ultrablack/60 backdrop-blur-md flex items-center justify-center z-[9999] pointer-events-none">
    <div
      className="bg-dark py-6 px-1.5 rounded-lg border-2 border-dashed border-tpg_light flex flex-col items-center justify-center text-center text-lg pointer-events-auto"
      style={{ width, height }}
    >
      <p className="text-tpg_title">{title}</p>
    </div>
  </div>
);

export default memo(DragOverlay);
